export enum IngestStorageEventsManagerType {
  FileSystemScanner = "FileSystemScanner",
  AsperaApiSync = "AsperaApiSync",
}
